import React, { useState, useRef, useEffect, useContext } from "react";
import Textinput from "../elements/TextInput/TextInput";
import Button from "../elements/Button/Button";
import { AuthContext } from "../../context/AuthContext";
import Notification from "../Notification/Notification";
import ClipLoader from "react-spinners/ClipLoader";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";

const Settings = () => {
  const { token } = useContext(AuthContext);
  const [notification, setNotification] = useState({ message: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);
  const passcodeInput = useRef(null);
  const [selectedFitment, setSelectedFitment] = useState("");

  const handleSelection = (value) => {
    setSelectedFitment(value);
  };

  useEffect(() => {
    loadSetting();
    getFitmentDetails();
  }, []);

  const getFitmentDetails = async () => {
    try {
      let email;
      const encryptedMetadata = localStorage.getItem("metadata");
      if (encryptedMetadata) {
        const decryptedMetadata = JSON.parse(
          CryptoJS.AES.decrypt(
            encryptedMetadata,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );
        if (decryptedMetadata && decryptedMetadata.cid)
          email = decryptedMetadata.email;
      }
      const getFitment = { email: email };
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(getFitment),
        process.env.REACT_APP_SECRETKEY
      ).toString();
      const encryptjson = { data: encryptedData };
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/getFitmentLevel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(encryptjson),
      });
      const data = await response.json();
      const decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          data.data,
          process.env.REACT_APP_SECRETKEY
        ).toString(CryptoJS.enc.Utf8)
      );
      console.log(decryptedData, "fitment detttt");
      setSelectedFitment(decryptedData);
    } catch (err) {
      console.log(err);
    }
  };

  const updateFitment = async () => {
    try {
      let email;
      const encryptedMetadata = localStorage.getItem("metadata");

      if (encryptedMetadata) {
        const decryptedMetadata = JSON.parse(
          CryptoJS.AES.decrypt(
            encryptedMetadata,
            process.env.REACT_APP_SECRETKEY
          ).toString(CryptoJS.enc.Utf8)
        );

        if (decryptedMetadata && decryptedMetadata.cid) {
          email = decryptedMetadata.email;
        }
      }

      if (!selectedFitment) {
        console.log("No fitment selected.");
        return;
      }
      const result = await Swal.fire({
        icon: "warning",
        title: "Do you want to update Fitment Leniency?",
        showConfirmButton: true,
        confirmButtonText: "OK",
        showCancelButton: true,
      });

      if (!result.isConfirmed) {
        console.log("Fitment update canceled.");
        return;
      }

      const Fitment = { fitmentLevel: selectedFitment, email: email };

      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(Fitment),
        process.env.REACT_APP_SECRETKEY
      ).toString();

      const encryptjson = { data: encryptedData };

      console.log("Selected Fitment:", selectedFitment);

      const serverURL = process.env.REACT_APP_SERVER_URL;

      const response = await fetch(`${serverURL}/updateFitmentLevel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(encryptjson),
      });

      const data = await response.json();
      console.log("Server Response:", data);
    } catch (error) {
      console.error("Error updating fitment:", error);
    }
  };

  const loadSetting = async () => {
    setIsLoading(true);
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${serverURL}/masters/getpasscode`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      });
      const data = await response.json();
      console.log(data);
      if (response.ok) {
        passcodeInput.current.value = data.data.passcode;
      } else {
        var errorMessage = "Something Went Wrong";
        if (data.error) errorMessage = data.error;
        throw errorMessage;
      }
    } catch (error) {
      var errorMessage = error;
      showNotification(errorMessage, "error");
    } finally {
      setIsLoading(false); // Always hide loader after the request
    }
  };

  const showNotification = (message, type) => {
    //For Notification
    setNotification({ message, type });
    setTimeout(() => {
      setNotification({ message: "", type: "" });
    }, 3000); // Auto-hide after 3 seconds
  };
  const savePasscode = async () => {
    const passcode = passcodeInput.current.value;
    if (!passcode) {
      showNotification("Passcode cannot be empty", "error");
      passcodeInput.current.classList.add("border-red-600");
      return;
    }

    setIsLoading(true);
    try {
      const serverURL = process.env.REACT_APP_SERVER_URL;
      var jsonData = { passcode: passcode };
      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(jsonData),
        process.env.REACT_APP_SECRETKEY
      ).toString();
      var encryptjson = { data: encryptedData };
      const response = await fetch(`${serverURL}/masters/savePasscode`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(encryptjson),
      });
      const data = await response.json();
      if (response.ok) {
        showNotification("Passcode saved successfully", "success");
      } else {
        var errorMessage = "Something Went Wrong";
        if (data.error) errorMessage = data.error;
        throw errorMessage;
      }
    } catch (error) {
      var errorMessage = error;
      showNotification(errorMessage, "error");
    } finally {
      setIsLoading(false);
    }
  };

  console.log("hello");
  console.log(selectedFitment, "selectedFitment");

  const onChangePAsscode = () => {
    passcodeInput.current.classList.remove("border-red-600");
  };
  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="flex flex-col items-center">
            <ClipLoader color="#3498db" loading={isLoading} size={50} />
            <span className="text-white mt-4">Loading...</span>
          </div>
        </div>
      )}
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: "", type: "" })}
      />
      <div className="w-full max-w-4xl mx-auto bg-white shadow-md items-center rounded-xl">
        <div className="p-4 sm:p-6 grid gap-4 items-center">
          <div className="w-full">
            <Textinput
              label="Gmail Passcode:"
              onChange={onChangePAsscode}
              InputRef={passcodeInput}
              className="w-full sm:w-3/5 md:w-2/5 focus:outline-none"
            />
          </div>
          <div className="flex flex-col sm:flex-row gap-4 sm:items-center">
            <Button
              onClick={savePasscode}
              className="py-2 px-4 text-white !rounded-lg flex justify-center items-center !bg-[#059669] w-full sm:w-auto"
            >
              <svg
                fill="#ffffff"
                viewBox="0 0 32 32"
                className="w-5 h-5 mr-2"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path d="M23.845 8.125c-1.395-3.701-4.392-6.045-8.92-6.045-5.762 0-9.793 4.279-10.14 9.861-2.779 0.889-4.784 3.723-4.784 6.933 0 3.93 3.089 7.249 6.744 7.249h0.889c0.552 0 1-0.448 1-1s-0.448-1-1-1h-0.889c-2.572 0-4.776-2.404-4.776-5.249 0-2.515 1.763-4.783 3.974-5.163l0.907-0.156-0.081-0.917-0.008-0.011c0-4.871 3.206-8.545 8.162-8.545 3.972 0 6.204 1.957 7.236 5.295l0.213 0.688 0.721 0.015c3.715 0.078 6.971 3.092 6.971 6.837 0 3.408-2.259 7.206-5.679 7.206h-0.285c-0.552 0-1 0.448-1 1s0.448 1 1 1v-0.003c5-0.132 7.883-4.909 7.883-9.203-0.001-4.617-3.619-8.304-8.141-8.791zM20.198 24.233c-0.279-0.292-0.731-0.292-1.010-0l-2.2 2.427v-10.067c0-0.552-0.448-1-1-1s-1 0.448-1 1v10.076l-2.128-2.373c-0.28-0.292-0.732-0.355-1.011-0.063l-0.252 0.138c-0.28 0.293-0.28 0.765 0 1.057l3.61 3.992c0.005 0.005 0.006 0.012 0.011 0.017l0.253 0.265c0.14 0.146 0.324 0.219 0.509 0.218 0.183 0.001 0.368-0.072 0.507-0.218l0.253-0.265c0.005-0.005 0.008-0.011 0.012-0.017l3.701-4.055c0.279-0.292 0.279-0.639 0-0.932z"></path>{" "}
                </g>
              </svg>
              Save
            </Button>
            <a
              href="https://www.youtube.com/watch?v=jjDNndrl7_U"
              target="blank"
              className="flex text-[#059669] justify-center sm:justify-start items-center"
            >
              What is it about?
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#059669"
                className="w-5 h-5 ml-1"
                viewBox="0 0 24 24"
              >
                <path d="M15.5 2.25a.75.75 0 01.75-.75h5.5a.75.75 0 01.75.75v5.5a.75.75 0 01-1.5 0V4.06l-6.22 6.22a.75.75 0 11-1.06-1.06L19.94 3h-3.69a.75.75 0 01-.75-.75z" />
                <path d="M2.5 4.25c0-.966.784-1.75 1.75-1.75h8.5a.75.75 0 010 1.5h-8.5a.25.25 0 00-.25.25v15.5c0 .138.112.25.25.25h15.5a.25.25 0 00.25-.25v-8.5a.75.75 0 011.5 0v8.5a1.75 1.75 0 01-1.75 1.75H4.25a1.75 1.75 0 01-1.75-1.75V4.25z" />
              </svg>
            </a>
          </div>
        </div>
        <div className="border-t border-gray-200">
          <p className="mb-0 mt-4 px-4 sm:px-6 font-[800] text-lg">
            Fitment Leniency
          </p>
          <div className="p-4 sm:p-6">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-4">
              {["PRECISE", "TOLERANT", "RELAXED"].map((fitment) => (
                <label
                  key={fitment}
                  className="flex items-center cursor-pointer bg-gray-50 p-3 rounded-lg border hover:bg-gray-100 transition-colors"
                >
                  <input
                    type="radio"
                    name="fitment"
                    value={fitment}
                    checked={selectedFitment === fitment}
                    onChange={() => handleSelection(fitment)}
                    className="mr-3 w-4 h-4 text-[#059669] bg-gray-100 border-gray-300 focus:ring-[#059669] focus:ring-2"
                  />
                  <span className="font-medium">{fitment}</span>
                </label>
              ))}
            </div>
            <Button
              className="py-2 px-4 text-white text-sm w-full sm:w-auto !bg-[#059669] hover:!bg-[#047857] transition-colors"
              onClick={updateFitment}
              disabled={!selectedFitment}
            >
              Update Fitment
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default Settings;
